import { render, staticRenderFns } from "./SpaceControllerView.vue?vue&type=template&id=70d8eaab&scoped=true"
import script from "./SpaceControllerView.vue?vue&type=script&lang=js"
export * from "./SpaceControllerView.vue?vue&type=script&lang=js"
import style0 from "./SpaceControllerView.vue?vue&type=style&index=0&id=70d8eaab&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70d8eaab",
  null
  
)

export default component.exports